import React from "react";
import { TuneIcon } from "../../utils/icons";
import "./LineupSubHeader.css";
import { getStatsColumnMapping } from "../../utils/columnsJsonInformation";
import { connect } from "react-redux";
function LineupSubHeader(props) {
  return (
    <>
      <div className="border-bottom border-secondary d-flex justify-content-center bg-dark">
        <div className="d-flex justify-content-center p-1 w-100 ">
          <ul className="nav nav-pills bg-secondary rounded p-1">
            <li className="nav-item">
              <button
                className="btn btn-sm nav-link btn-dark text-white"
                style={{ cursor: "not-allowed" }}
                id="summary"
              >
                Lineups
              </button>
            </li>
            {/* <li className="nav-item">
              <button className="btn btn-sm nav-link text-white" id="gamelog">
                Exposure
              </button>
            </li> */}
          </ul>
        </div>
        {/* <div
          className="disabled d-flex justify-content-end mr-3"
          // style={{ cursor: "pointer" }}
          // data-toggle="modal"
          // data-target="#staticBackdropLineUpSort"
        >
          <TuneIcon className="align-items-center align-self-center text-primary rotate-90" />
        </div> */}
      </div>

      <div
        className="modal fade"
        id="staticBackdropLineUpSort"
        data-backdrop="staticLineUp"
        tabindex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabelLineUp"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header d-flex bg-dark text-center text-white lead">
              Lineup Sort
              <button
                type="button"
                className="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="bg-black">
              <ul className="list-group m-2">
                {props.league &&
                  getStatsColumnMapping(props.league, props.remoteConfig)
                    .filter((column) => column.lineup_param == true)
                    .map((column, index) => (
                      <li
                        key={index}
                        className="d-flex list-group-item bg-dark text-white"
                        aria-label="Large"
                        aria-describedby="inputGroup-sizing-sm"
                        data-dismiss="modal"
                        style={{ cursor: "pointer" }}
                      >
                        <b>{column.display_name}</b>
                      </li>
                    ))}
              </ul>
            </div>

            <div className="modal-footer bg-black">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    league: state.gameInformationReducer.sports,
  };
};
export default connect(mapStateToProps)(LineupSubHeader);
